import useRoutes from '../../../../hooks/useRoutes';
import styles from './Cover.module.scss';
import CoverTopHome from './coverTopHome/CoverTopHome';
import SelectorsContainer from './selectorsContainer/SelectorsContainer';

const Cover = ({ isChristmas }: { isChristmas?: boolean }) => {
    const { routes, currentPathname } = useRoutes();
    const isHomePage =
        currentPathname === routes.home ||
        currentPathname === routes.homeLocale ||
        currentPathname === routes.aloyHome ||
        currentPathname === routes.flykubeHome;
    // const landingInfoIsLoading = useRef<boolean>(false);
    // const dispatch = useAppDispatch();
    // const lang = i18n.language ?? 'en';
    // const { slug }: IPromoData = useAppSelector((state) => state.landing.homeCoverPromoData);

    // const getPromoInfo = () => {
    //     if (landingInfoIsLoading.current) return;
    //     landingInfoIsLoading.current = true;
    //     APIKit.get(`landing/page/${slug}/`)
    //         .then((res) => {
    //             const promoData: IPromoData = res.data;
    //             dispatch(setHomeData(promoData));
    //         })
    //         .catch(() => {})
    //         .finally(() => {
    //             landingInfoIsLoading.current = false;
    //         });
    // };

    // useEffect(() => {
    //     if (lang) {
    //         getPromoInfo();
    //     }
    // }, [lang]);

    return (
        <section className={`${styles.coverContainer} ${isHomePage && !isChristmas && styles.coverContainerHome}`}>
            <CoverTopHome />

            <SelectorsContainer />
        </section>
    );
};

export default Cover;
